<template>
  <main>
    <b-alert class="mb-2" show>
      <div class="p-2">
        <h1 class="text-dark"><strong>Halo {{ myName }}</strong></h1>
        <h4 class="text-secondary">Selamat Datang Kembali!</h4>
      </div>
    </b-alert>
    <div v-if="level.nama_level == 'Admin'"><admin /></div>
    <div v-else-if="level.nama_level == 'Owner'"><owner /></div>
    <div v-else-if="level.nama_level == 'Finance'"><finance /></div>
    <div v-else-if="level.nama_level == 'General Manager'"><gm /></div>
    <div v-else-if="level.nama_level == 'Sales'"><sales /></div>
    <div v-else-if="level.nama_level == 'Admin Gudang'"><gudang /></div>
    <div v-else-if="level.nama_level == 'SPV'"><spv /></div>
    <div v-else-if="level.nama_level == 'Human Resource'"><human /></div>
    <div v-else><aset /></div>
  </main>
</template>
<script>
import { BAlert } from "bootstrap-vue";
import Admin from "./component-dashboard/admin.vue";
import Owner from "./component-dashboard/owner.vue";
import Sales from "./component-dashboard/sales.vue";
import Finance from "./component-dashboard/finance.vue";
import Spv from "./component-dashboard/spv.vue";
import Aset from "./component-dashboard/aset.vue";
import Gm from "./component-dashboard/gm.vue";
import Gudang from "./component-dashboard/gudang.vue";
import Human from "./component-dashboard/hr.vue";
export default {
  data() {
    return {
      level: JSON.parse(localStorage.getItem("userData")).level,
    };
  },
  components: {
    BAlert,
    Admin,
    Owner,
    Sales,
    Finance,
    Spv,
    Aset,
    Gm,
    Gudang,
    Human,
  },
  computed: {
    myName() {
      if (this.user) {
        return this.user.karyawan ? this.user.karyawan.nama_lengkap : this.user.email;
      }

      return null;
    },
  }
};
</script>
